// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zdrfp","type":"styles_type__1Cmki","choices":"styles_choices__1PvOV"};